import React from "react";
import { useTranslation } from "react-i18next";
import "./telecomSector.scss";

function TelecomSector() {
  const { t } = useTranslation()

  return (
    <div className="container-telecom-sector">
      <div>
        <div className="title-telecom-sector">
          <h1>
            {t("examples.telecom_sector.billing_policy.title")} <br /> {t("examples.telecom_sector.billing_policy.section_text")}
          </h1>
        </div>
        <div className="div-telecom-sector">
          <div className="need">
            <h1>{t("examples.telecom_sector.billing_policy.needs.title")}</h1>
            <div className="texto-need">
              <ul>
                <li><p>{t("examples.telecom_sector.billing_policy.needs.section_text_1")}</p></li>
                <li><p>{t("examples.telecom_sector.billing_policy.needs.section_text_2")}</p></li>
                <li><p>{t("examples.telecom_sector.billing_policy.needs.section_text_3")}</p></li>
              </ul>
            </div>
          </div>
          <br />
          <div className="solution">
            <h1>{t("examples.telecom_sector.billing_policy.solutions.title")}</h1>
            <div className="texto-solution">
              <ul>
                <li><p>{t("examples.telecom_sector.billing_policy.solutions.section_text")}</p></li>
              </ul>
            </div>
          </div>
          <br />
          <div className="results">
            <h1>{t("examples.telecom_sector.billing_policy.results.title")}</h1>
            <div className="texto-results">
              <ul>
                <li><p>{t("examples.telecom_sector.billing_policy.results.section_text_1")} <br /> {t("examples.telecom_sector.billing_policy.results.procon_text")}</p></li>
                <li><p>{t("examples.telecom_sector.billing_policy.results.section_text_2")}</p></li>
                <li><p>{t("examples.telecom_sector.billing_policy.results.section_text_3")}</p></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="title-telecom-sector">
          <h1>{t("examples.telecom_sector.charging_policy.title")}<br /> {t("examples.telecom_sector.charging_policy.section_text")}</h1>
        </div>
        <div className="div-telecom-sector">
          <div className="need">
            <h1>{t("examples.telecom_sector.charging_policy.needs.title")}</h1>
            <div className="texto-need">
              <ul>
                <li><p>{t("examples.telecom_sector.charging_policy.needs.section_text_1")}</p></li>
                <li><p>{t("examples.telecom_sector.charging_policy.needs.section_text_2")}</p></li>
                <li><p>{t("examples.telecom_sector.charging_policy.needs.section_text_3")}</p></li>
              </ul>
            </div>
          </div>
          <br />
          <div className="solution">
            <h1>{t("examples.telecom_sector.charging_policy.solutions.title")}</h1>
            <div className="texto-solution">
              <ul>
                <li>
                  <p>{t("examples.telecom_sector.charging_policy.solutions.section_text")}</p>
                </li>
              </ul>
            </div>
          </div>
          <br />
          <div className="results">
            <h1>{t("examples.telecom_sector.charging_policy.results.title")}</h1>
            <div className="texto-results">
              <ul>
                <li>
                  <p>{t("examples.telecom_sector.charging_policy.results.section_text_1")}</p>
                </li>
                <li>
                  <p>{t("examples.telecom_sector.charging_policy.results.section_text_2")}</p>
                </li>
                <li>
                  <p>{t("examples.telecom_sector.charging_policy.results.section_text_3")}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TelecomSector;
